import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri';
import Slide from '@mui/material/Slide';
import { useMutation, useQueryClient } from 'react-query';
import FormHelperText from '@mui/material/FormHelperText';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

import { logUser } from '../../api/admin';
import { useNotification } from '../../context/notification';
import { useAuth } from '../../context/auth';

function Login() {
  const { addNotification } = useNotification();
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    username: { value: '', error: false },
    password: { value: '', error: false },
  });

  const navigate = useNavigate();
  const auth = useAuth();

  const { mutate: handleLogin, isLoading: loginIsLoading } = useMutation((data) => logUser(data), {
    onSuccess: (data) => {
      auth.login(data.user);
      navigate('/', { replace: true });
      queryClient.invalidateQueries('user');
    },
    onError: (err) => {
      addNotification({ message: `Une erreur est survenue lors de l'authentification ${err.message}`, severity: 'error' });
    },
  });

  const handleSubmit = () => {
    if (!formData.username.value) {
      setFormData((prev) => ({ ...prev, username: { ...prev.username, error: true } }));
    }
    if (!formData.password.value) {
      setFormData((prev) => ({ ...prev, password: { ...prev.password, error: true } }));
    }
    if (formData.username.error || formData.password.error) return;
    handleLogin({ username: formData.username.value, password: formData.password.value });
  };

  return (
    <section className="bg-zinc-900 px-6 flex items-center justify-center authForm">
      <Slide direction="up" in mountOnEnter unmountOnExit>
        <div className="bg-zinc-700 p-8 rounded" style={{ maxWidth: '400px' }}>
          <TextField
            error={formData.username.error}
            fullWidth
            sx={{ marginBottom: '1rem' }}
            helperText={formData.username.error && 'Valeur incorrect.'}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            required
            value={formData.username.value}
            label="Identifiant"
            onChange={(e) => setFormData((prev) => ({ ...prev, username: { error: false, value: e.target.value } }))}
            variant="standard"
            size="small"
          />
          <FormControl error={formData.password.error} fullWidth required variant="standard">
            <InputLabel>Mot de passe</InputLabel>
            <Input
              autoComplete="off"
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              id="standard-adornment-password"
              type={formData.showPassword ? 'text' : 'password'}
              onChange={(e) => setFormData((prev) => ({ ...prev, password: { error: false, value: e.target.value } }))}
              size="small"
              value={formData.password.value}
              endAdornment={
                <button
                  type="button"
                  className="focus"
                  aria-label="toggle password visibility"
                  onClick={() => setFormData((prev) => ({ ...prev, showPassword: !prev.showPassword }))}
                >
                  {formData.showPassword ? <RiEyeOffFill color="white" /> : <RiEyeFill color="white" />}
                </button>
              }
            />
            {formData.password.error && <FormHelperText>Valeur incorrect.</FormHelperText>}
          </FormControl>
          <button
            type="button"
            onClick={() => handleSubmit()}
            disabled={!formData.username || !formData.password}
            className="px-4 py-2 mt-8 rounded bg-zinc-900 hover:bg-blue-500 duration-500 disabled:opacity-50 disabled:hover:bg-zinc-900"
          >
            {loginIsLoading ? <CircularProgress size={13} /> : 'Connexion'}
          </button>
        </div>
      </Slide>
    </section>
  );
}

Login.propTypes = {};
Login.defaultProps = {};

export default Login;
